import { render, staticRenderFns } from "./UPreRegisterResendComp.vue?vue&type=template&id=e74a8614&scoped=true&"
import script from "./UPreRegisterResendComp.vue?vue&type=script&lang=ts&"
export * from "./UPreRegisterResendComp.vue?vue&type=script&lang=ts&"
import style0 from "./UPreRegisterResendComp.vue?vue&type=style&index=0&id=e74a8614&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e74a8614",
  null
  
)

export default component.exports